import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { copyDiagnostics } from '../../utils/callReliability/diagnostics';
export default function DiagnosticsButton() {
	const [message, setMessage] = useState('');
	return (
		<div>
			<Button
				onClick={() => {
					void copyDiagnostics()
						.then(setMessage)
						.catch(() =>
							setMessage(
								'Unable to save diagnostics. Please try again.',
							),
						);
				}}
			>
				Copy call diagnostics
			</Button>
			{message && (
				<Typography role="status" variant="body2">
					{message}
				</Typography>
			)}
		</div>
	);
}
